import styled from 'styled-components';
import ContentEditable from 'react-contenteditable';
import {
  Link,
} from 'react-router';

export interface ItemProps {
  selected: boolean;
}

export const Item = styled(Link)<ItemProps>`
  color: #757575;
  font-size: 19px;
  font-weight: bold;
  line-height: 31px;
  padding: 0;
  margin: 0;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.colors.link};
  }

  &:not(:last-child):after {
    content: "\\f054";
    color: #989898;
    font-family: "Font Awesome 5 Free";
    font-size: 8px;
    line-height: 18px;
    vertical-align: 2px;
    margin-left: 10px;
    display: inline-block;
  }

  @media print {
    &:not(:last-child) {
      display: none;
    }
    &:last-child {
      color: #000;
      margin-left: -15px;
    }
  }

  ${props => props.selected && `
    color: ${props.theme.colors.link};
    cursor: default;
    @media print {
      color: #000;
      font-size: 31px;
      font-weight: bold;
      display: block;
      &:hover {
        color: #000;
      }
    }
  `};
`;

export const EditableItem = styled(ContentEditable)`
  color: ${props => props.theme.colors.link};
  font-size: 19px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 3px;
  margin-right: -3px;
  border-radius: 5px;
  border: 1px solid transparent;

  outline: none;
  box-shadow: none;

  &:focus {
    border-color: #ddd;
  }
`;
